'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = CollaborationCard;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var avatarStyle = {
  width: 50,
  height: 50,
  marginTop: 0,
  marginRight: 10,
  marginBottom: 0,
  marginLeft: 0
};

var nameH3Style = {
  marginTop: 5,
  float: 'left',
  marginBottom: -2
};

var socialHandleStyle = {
  color: 'gray'
};

var socialNetworkWrapperStyle = {
  fontSize: 12,
  textAlign: 'center'
};

var socialNetworkImageStyle = {
  width: 24,
  height: 24,
  display: 'block',
  margin: '0 auto',
  marginTop: 5
};

var zeroFollowersSpanStyle = {
  color: 'gray'
};

var socialNetworkLinkStyle = {
  color: 'rgb(32, 196, 158)',
  fontWeight: 'bold'
};

var SocialNetworkLink = function SocialNetworkLink(_ref) {
  var link = _ref.link,
      count = _ref.count,
      platform = _ref.platform;

  var hasFollowers = count > 0;
  return _react2.default.createElement(
    'div',
    { style: socialNetworkWrapperStyle },
    _react2.default.createElement(_semanticUiReact.Image, {
      src: 'https://app.dyzio.co/icons/' + platform + '.svg',
      style: socialNetworkImageStyle
    }),
    hasFollowers && _react2.default.createElement(
      'a',
      {
        href: link,
        target: '_blank',
        rel: 'noopener noreferrer',
        style: socialNetworkLinkStyle
      },
      (0, _formatting.scientificFormatted)(count)
    ),
    !hasFollowers && _react2.default.createElement(
      'span',
      { style: zeroFollowersSpanStyle },
      '0'
    )
  );
};

function CollaborationCard(_ref2) {
  var onClick = _ref2.onClick,
      name = _ref2.name,
      thumbnail = _ref2.thumbnail,
      primarySocialHandle = _ref2.primarySocialHandle,
      facebook = _ref2.facebook,
      twitter = _ref2.twitter,
      instagram = _ref2.instagram,
      youtube = _ref2.youtube,
      facebookCount = _ref2.facebookCount,
      twitterCount = _ref2.twitterCount,
      instagramCount = _ref2.instagramCount,
      youtubeCount = _ref2.youtubeCount,
      cardProps = (0, _objectWithoutProperties3.default)(_ref2, ['onClick', 'name', 'thumbnail', 'primarySocialHandle', 'facebook', 'twitter', 'instagram', 'youtube', 'facebookCount', 'twitterCount', 'instagramCount', 'youtubeCount']);

  return _react2.default.createElement(
    _semanticUiReact.Card,
    (0, _extends3.default)({}, cardProps, { fluid: true }),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 'eight' },
            _react2.default.createElement(_semanticUiReact.Image, {
              className: 'circular',
              src: thumbnail,
              style: avatarStyle,
              floated: 'left',
              size: 'tiny'
            }),
            _react2.default.createElement(
              'h3',
              { style: nameH3Style },
              name
            ),
            _react2.default.createElement(
              'h5',
              { style: socialHandleStyle },
              primarySocialHandle
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 'two' },
            _react2.default.createElement(SocialNetworkLink, {
              platform: 'facebook',
              count: facebookCount,
              link: 'https://facebook.com/' + facebook
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 'two' },
            _react2.default.createElement(SocialNetworkLink, {
              platform: 'instagram',
              count: instagramCount,
              link: 'https://instagram.com/' + instagram
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 'two' },
            _react2.default.createElement(SocialNetworkLink, {
              platform: 'twitter',
              count: twitterCount,
              link: 'https://twitter.com/' + twitter
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 'two' },
            _react2.default.createElement(SocialNetworkLink, {
              platform: 'youtube',
              count: youtubeCount,
              link: 'https://youtube.com/channel/' + youtube
            })
          )
        )
      )
    )
  );
}

CollaborationCard.propTypes = {
  onClick: _propTypes2.default.func,
  name: _propTypes2.default.string.isRequired,
  thumbnail: _propTypes2.default.string.isRequired,
  primarySocialHandle: _propTypes2.default.string.isRequired
};

CollaborationCard.defaultProps = {
  onClick: _lodash2.default.noop
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/collaboration-card/index.js
 ** module id = 2550
 ** module chunks = 0
 **/